import { render, staticRenderFns } from "./system_item.vue?vue&type=template&id=623cc306&scoped=true&"
import script from "./system_item.vue?vue&type=script&lang=js&"
export * from "./system_item.vue?vue&type=script&lang=js&"
import style0 from "./system_item.vue?vue&type=style&index=0&id=623cc306&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623cc306",
  null
  
)

export default component.exports